export var LanguageString;
(function (LanguageString) {
    LanguageString["English"] = "en";
    LanguageString["Spanish"] = "es";
})(LanguageString || (LanguageString = {}));
